import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";

interface MultiRestaurantErrorDialogProps {
  open: boolean;
  onClose: () => void;
}

const MultiRestaurantErrorDialog: React.FC<MultiRestaurantErrorDialogProps> = ({ open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Error: Only One Restaurant Per Order</DialogTitle>
      <DialogContent>
        <DialogContentText>
          You can only order from one restaurant at a time. Please complete or remove items from your current order before adding items from another restaurant.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="contained">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MultiRestaurantErrorDialog;
